/* dividido em um mixin para que possa ser usado em varios lugares da tela de compra por departamento */
import pushTelaComprasPorDepartamentos from "../../../dashboard/departamentos/helpers/PushTelaComprasPorDepartamentos";
import {card_selecionado} from "./CardSelecionado.js";

export const parametros_rota = {
  mixins: [pushTelaComprasPorDepartamentos, card_selecionado],
  computed: {
    grupo_compra: {
      get: function () {
        return parseInt(this.$route.params.id_grupo);
      },
      set: function (id) {
        this.pushTelaComprasPorDepartamentos({...this.$route.params, id_filial: 9999, id_grupo: id});
      }
    },
    filial_compra: {
      get: function () {
        return parseInt(this.$route.params.id_filial);
      },
      set: function (id) {
        this.pushTelaComprasPorDepartamentos({...this.$route.params, id_filial: id});
      }
    },
    departamento_compra: {
      get: function () {
        return `${this.$route.params.id_departamento}`;
      },
      set: function (id) {
        this.pushTelaComprasPorDepartamentos({...this.$route.params, id_departamento: id});
      }
    },
    PARAMETROS() {
      return {
        grupo: this.grupo_compra,
        filial: this.filial_compra,
        iddepartamento: this.departamento_compra,
        card: this.card_selecionado.chave
      }
    }
  },
}
